export default function homg_percentage (value) {

    if (!value) {
        return '-'
    } else {
        value = Number(value)

        if (value === 0) {
            return '-'
        }

        if (value > 0) {

            return '+' + value + ' %'
        }else{
            return value + ' %'
        }

    }

}


// WEBPACK FOOTER //
// ./src/formatters/percentage.js